import React, { useEffect, useState } from 'react';
import UserNftSection from '../components/UserNftSection';
import { formatPrice, getContract } from '../hooks/contractHelper';
import { useAccountStats, useDaoBscRewardStats, useDaoEthRewardStats, useDaoRewardStats } from '../hooks/useAccount';
import { useAccount, useNetwork } from 'wagmi';
import { DAO_REWARD, DAO_SUPPOTED_CHAIN, DEFAULT_CHAIN } from '../hooks/constant';
import daorewardABI from '../json/daoreward.json'
import { useEthersSigner } from '../hooks/useEthersProvider';
import { toast } from 'react-toastify';
import { getWeb3 } from '../hooks/connectors';
import RewardModal from '../components/RewardModal';
import ClaimedModal from '../components/ClaimedModal';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Footer from '../components/Footer';


export default function Profile() {
  const [updater, setUpdater] = useState(1)
  const accStats = useAccountStats(updater);
  const rewardStats = useDaoRewardStats(updater);
  const rewardBscStats = useDaoBscRewardStats(updater);
  const rewardEthStats = useDaoEthRewardStats(updater);
  const { address } = useAccount();
  const { chain } = useNetwork();
  const library = useEthersSigner();
  const [show, setShow] = useState(false);
  const [cshow, setCShow] = useState(false);
  const [selectedChain, setSelectedChain] = useState(5512);
  const [data, setData] = useState([]);
  const history = useHistory();
  

  const handleClaim = async (id = 5512) => {

    try {
      if (address) {
        if (chain && chain.id && chain.id === id && (DAO_SUPPOTED_CHAIN.includes(id) || DEFAULT_CHAIN === chain.id)) {

          let daoContract = getContract(daorewardABI, DAO_REWARD[id].DAO_REWARD_ADDRESS, library);
          let tx = await daoContract.claim({ 'from': address });
          toast.loading('Waiting for confirmation..');
          var interval = setInterval(async function () {
            let web3 = getWeb3(DAO_REWARD[id].RPC_URL);
            var response = await web3.eth.getTransactionReceipt(tx.hash);
            if (response != null) {
              clearInterval(interval)
              if (response.status === true) {
                toast.dismiss();
                toast.success('success ! your last transaction is success');

                setUpdater(1);
              }
              else if (response.status === false) {
                toast.dismiss();
                toast.error('error ! Your last transaction is failed.');

              }
              else {
                toast.dismiss();
                toast.error('error ! something went wrong.');

                setUpdater(1);
              }
            }
          }, 5000);

        }
        else {
          toast.dismiss();
          toast.error('Please connect to mainnet chain!!');

        }
      }
      else {
        toast.dismiss();
        toast.error('Please connect wallet!!');

      }
    }
    catch (err) {
      toast.dismiss();
      toast.error(err.reason ? err.reason : err.message);
    }
  }

  useEffect(() => {
    let isLogin = localStorage.getItem("blockstardao");
    if (isLogin === null || isLogin === 'null') {
      history.push('/')
    }

  }, []);

  return (

    <div id="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="row g-0 mt-5 ">
            <div className="col-lg-4 col-md-6">
              <div className="card border info-card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="d-flex no-block align-items-center">
                        <div>
                          <h3><i className="icon-grid"></i></h3>
                          <p className="text-white">Your Balance</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 main-text-below">
                      {accStats.token_balance ? formatPrice(accStats.token_balance) : 0} BST
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="card border info-card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="d-flex no-block align-items-center">
                        <div>
                          <h3><i className="icon-briefcase"></i></h3>
                          <p className="text-white">Holding Worth</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 main-text-below">
                      ${accStats.holdingWorth ? formatPrice(accStats.holdingWorth) : 0}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="card border info-card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="d-flex no-block align-items-center">
                        <div>
                          <h3><i className="icon-chart"></i></h3>
                          <p className="text-white">Your NFT Balance</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 main-text-below">
                      {accStats.nft_balance ? formatPrice(accStats.nft_balance) : 0} BLOCKSTAR DAO
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* reward state */}
            <div className="col-lg-4 col-md-6">
              <div className="card border info-card">
                <div className="card-body">
                  <div className="row d-flex align-items-center">
                    <div className="col-md-12">
                      <div className="d-flex no-block justify-content-between align-items-center">
                        <div>
                          <h3><i className="icon-chart"></i></h3>
                          <p className="text-white">BlockStar Chain Reward</p>
                        </div>

                      </div>
                    </div>
                    <div className="col-4 main-text-below">
                      <span className='fs-5' style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => {
                        setSelectedChain(5512)
                        setCShow(true)
                        setShow(false);
                      }}>
                        Total Claimed
                      </span>
                    </div>
                    <div className={`col-4 main-text-below ${rewardStats.finalData && rewardStats.finalData.length === 0 ? 'mb-1' : ''}`}>
                      {rewardStats.finalData && rewardStats.finalData.length > 0 ? (
                        <span className='fs-5' style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => {
                          setData(rewardStats.finalData);
                          setShow(true);
                        }}>Total Pending</span>
                      ) : (
                        <></>
                      )}
                    </div>

                    {rewardStats.finalData && rewardStats.finalData.length > 0 &&
                      <div className="col-4 main-text-below">
                        <button type='button' onClick={() => handleClaim(5512)} className='btn btn-warning text-white'>Claim</button>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>


            <div className="col-lg-4 col-md-6">
              <div className="card border info-card">
                <div className="card-body">
                  <div className="row d-flex align-items-center">
                    <div className="col-md-12">
                      <div className="d-flex no-block justify-content-between align-items-center">
                        <div>
                          <h3><i className="icon-chart"></i></h3>
                          <p className="text-white">Etherum Chain Reward</p>
                        </div>

                      </div>
                    </div>
                    <div className="col-4 main-text-below">
                      <span className='fs-5' style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => {
                        setSelectedChain(11155111)
                        setCShow(true)
                        setShow(false);
                      }}>
                        Total Claimed
                      </span>
                    </div>
                    <div className={`col-4 main-text-below ${rewardEthStats.finalData && rewardEthStats.finalData.length === 0 ? 'mb-1' : ''}`}>
                      {rewardEthStats.finalData && rewardEthStats.finalData.length > 0 ? (
                        <span className='fs-5' style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => {
                          setData(rewardEthStats.finalData);
                          setShow(true);
                        }}>Total Pending</span>
                      ) : (
                        <></>
                      )}
                    </div>

                    {rewardEthStats.finalData && rewardEthStats.finalData.length > 0 &&
                      <div className="col-4 main-text-below">
                        <button type='button' onClick={() => handleClaim(11155111)} className='btn btn-warning text-white'>Claim</button>
                      </div>
                    }

                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="card border info-card">
                <div className="card-body">
                  <div className="row d-flex align-items-center">
                    <div className="col-md-12">
                      <div className="d-flex no-block justify-content-between align-items-center">
                        <div>
                          <h3><i className="icon-chart"></i></h3>
                          <p className="text-white">Binance Chain Reward</p>
                        </div>

                      </div>
                    </div>
                    <div className="col-4 main-text-below">
                      <span className='fs-5' style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => {
                        setSelectedChain(56)
                        setCShow(true)
                        setShow(false);
                      }}>
                        Total Claimed
                      </span>
                    </div>
                    <div className={`col-4 main-text-below ${rewardBscStats.finalData && rewardBscStats.finalData.length === 0 ? 'mb-1' : ''}`}>
                      {rewardBscStats.finalData && rewardBscStats.finalData.length > 0 ? (
                        <span className='fs-5' style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => {
                          setData(rewardBscStats.finalData);
                          setShow(true);
                        }}>Total Pending</span>
                      ) : (
                        <></>
                      )}
                    </div>

                    {rewardBscStats.finalData && rewardBscStats.finalData.length > 0 &&
                      <div className="col-4 main-text-below">
                        <button type='button' onClick={() => handleClaim(56)} className='btn btn-warning text-white'>Claim</button>
                      </div>
                    }

                  </div>
                </div>
              </div>
            </div>

          </div>
          <UserNftSection />
          <RewardModal show={show} setShow={setShow} data={data} />
          <ClaimedModal show={cshow} setShow={setCShow} chainId={selectedChain} />
        </div>
      </div>
      <Footer />
    </div>

  )
}
